@if (isActive) {
  <div class="full-page-loader" animate.leave="full-page-loader--leaving">
    <img class="full-page-loader__img" [src]="loaderImageUrl" alt="{{ 'home-page.hero-block' | translate }}">
    <h1 class="full-page-loader__title">{{ 'home-page.hero-block' | translate }}</h1>
    <h2 class="full-page-loader__subtitle">{{'home-page.subtitle' | translate }}</h2>
  </div>
}
